<template>
  <div class="bg-white">
    <div class="flex mdmax:flex-col shadow-border-b">
      <div class="p-6 flex-1 shadow-border-r mdmax:shadow-border-b">
        <p class="font-bold text-lg mb-6">{{ $t('admin.detail.userInfo') }}</p>
        <div class="mb-6 w-56">
          <TextField :label="$t('admin.detail.id')" disabled v-model="userDetail.id" />
        </div>
        <div class="flex items-start gap-6 mb-6">
          <div class="flex-1">
            <TextField :label="$t('admin.detail.name')" v-model="userDetail.name" />
          </div>
          <div class="flex-1">
            <TextField :label="$t('admin.detail.email')" v-model="userDetail.email" />
          </div>
        </div>
        <div class="flex items-start gap-6 mb-6">
          <div class="flex-1">
            <TextField type="number" :label="$t('admin.detail.phone')" v-model="userDetail.phone_number" />
          </div>
          <div class="flex-1">&nbsp;</div>
        </div>
      </div>
      <div class="p-6 flex-1 mdmax:flex-auto mdmax:w-full"></div>
    </div>
    <div class="p-6 flex justify-end items-center gap-4">
      <Button :buttonText="$t('admin.detail.update')" type="primary" @action="update()" :disabled="isDisabled" />
      <Button :buttonText="$t('admin.detail.delete')" type="delete" @action="toggleDeleteConfirmation()" />
    </div>
    <Modal :modalVisible="visibleDeleteConfirmation" @close="toggleDeleteConfirmation()" width="600px" id="delete-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0">
            <Alert color="neutral-700" />
          </span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">{{ $t('admin.detail.modalTitle') }}</p>
            <p class="text-sm text-neutral-500 text-left">
              {{ $t('admin.detail.modalDesc') }}
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button :buttonText="$t('admin.detail.no')" type="secondary" @action="toggleDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button :buttonText="$t('admin.detail.yes')" type="primary" @action="confirmDelete()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDateTime } from '@/util'
export default {
  filters: {
    formatDateTime
  },
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    Button: () => import(/* webpackChunkName: "Button" */ '@/components/Forms/Button')
  },
  data() {
    return {
      visibleDeleteConfirmation: false
    }
  },
  computed: {
    ...mapGetters('merchant', ['userDetail']),
    userId() {
      return this.$route.params.id
    },
    isDisabled() {
      return !this.userDetail.name || !this.userDetail.email || !this.userDetail.phone_number
    }
  },
  methods: {
    ...mapActions('merchant', ['getMerchantUserDetail', 'updateMerchantUser', 'deleteMerchantUser']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    getAdminInfo() {
      this.showLoading()
      this.getMerchantUserDetail({
        userId: this.userId
      }).then(() => {
        this.hideLoading()
      })
    },
    toggleDeleteConfirmation() {
      this.visibleDeleteConfirmation = !this.visibleDeleteConfirmation
    },
    confirmDelete() {
      this.showLoading()
      this.toggleDeleteConfirmation()
      this.deleteMerchantUser({
        userId: this.userId
      }).then(() => {
        this.hideLoading()
        this.handleCallback()
      })
    },
    update() {
      this.showLoading()
      const payload = {
        name: this.userDetail.name,
        email: this.userDetail.email,
        phone_number: this.userDetail.phone_number
      }
      this.updateMerchantUser({
        userId: this.userId,
        payloads: payload
      })
        .then(() => {
          this.hideLoading()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Update User Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
        .catch(res => {
          this.hideLoading()
          this.setToast({
            options: { type: 'danger', duration: 4000, primaryText: `Perubahan User Gagal, ${res.response.data.message}`, secondaryText: 'Silakan coba lagi.', callback: () => {} }
          })
        })
    },
    handleCallback() {
      this.$router.push('/admin')
    }
  },
  created() {
    this.getAdminInfo()
  }
}
</script>

<style></style>
